import React, { Fragment } from 'react';
import Login from '../auth/Login';

const Landing = () => {
  return (
    <Fragment>
      <Login />
    </Fragment>
  );
};

export default Landing;



// WEBPACK FOOTER //
// ./src/components/Layout/Landing.js